<template>
  <b-modal
    :visible="visible"
    @shown="onShown"
    @hidden="$emit('update:visible', false)"
    :title="`Choisir une ${type}`"
    centered
    size="lg"
    hide-footer
  >
    <div class="mb-3">
      <b-form-input
        v-model="search"
        placeholder="Rechercher par nom, taille, volume…"
      />
    </div>

    <b-list-group>
      <b-list-group-item
        v-for="item in filteredItems"
        :key="item._id"
        class="d-flex justify-content-between align-items-center"
      >
        <div class="flex-grow-1 mr-2">
          <strong>
            <template v-if="type === 'voile'">
              <span v-if="item.guc_id" class="text-muted mr-1">{{ item.guc_id }}</span>
              {{ item.full_name }}
            </template>
            <template v-else>
              <span v-if="item.brand" class="mr-1">{{ item.brand }}</span>
              {{ item.full_name }}
            </template>
          </strong>
          <br />
          <small class="text-muted">
            <template v-if="type === 'voile'">
              <span v-if="item.brand">{{ item.brand }}</span>
              <span v-if="item.brand && typeof item.size === 'number'"> · </span>
              <span v-if="typeof item.size === 'number'">{{ item.size }} m²</span>
            </template>
            <template v-else>
              <span v-if="typeof item.volume === 'number'">{{ item.volume }} L</span>
            </template>
          </small>
        </div>
        <div class="d-flex align-items-center">
          <b-badge
            v-if="type === 'voile'"
            :variant="item.rigged ? 'success' : 'secondary'"
            pill
            class="mr-2"
          >
            {{ item.rigged ? 'Gréée' : 'Non gréée' }}
          </b-badge>
          <b-button
            size="sm"
            variant="success"
            @click="selectItem(item)"
          >
            Choisir
          </b-button>
        </div>
      </b-list-group-item>
    </b-list-group>

    <div class="text-right mt-4">
      <b-button variant="outline-danger" @click="clearSelection">
        Effacer la sélection
      </b-button>
    </div>
    <br>
    <br>
  </b-modal>
</template>

<script>
import GearService from "@/services/gear.service";

export default {
  name: "GearSelectModal",
  props: {
    visible: Boolean,
    type: {
      type: String,
      required: true // 'voile' ou 'planche'
    },
    participant: Object
  },
  data() {
    return {
      items: [],
      search: ""
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter(item =>
        JSON.stringify(item).toLowerCase().includes(this.search.toLowerCase())
      );
    }
  },
  methods: {
    onShown() {
      this.fetchItems();
    },
    fetchItems() {
      const listRequest =
        this.type === "voile" ? GearService.listSails() : GearService.listBoards();

      listRequest
        .then(res => res.data)
        .then(data => {
          this.items = data;
        })
        .catch(err => {
          console.error("Erreur de chargement :", err);
        });
    },
    selectItem(item) {
      this.$emit("selected", item);
    },
    clearSelection() {
      this.$emit("selected", null);
    }
  }
};
</script>

<style scoped>
.b-list-group-item {
  cursor: default;
}
</style>
